(() => {
  const script = document.currentScript;
  const sources = script?.dataset || {};
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const animationSelectors = [
    '.patine-animation-lab',
    '.patine-hero',
    '.patine-featured-works',
    '.patine-cta-block',
    '.patine-testimonials',
    '.patine-credibility',
  ];
  let readyPromise = null;

  const loadScript = (src) => {
    if (!src) return Promise.resolve();

    const existing = document.querySelector(`script[src="${src}"]`);
    if (existing?.dataset.patineLoaded === 'true') return Promise.resolve();

    return new Promise((resolve, reject) => {
      const node = existing || document.createElement('script');
      node.src = src;
      node.defer = true;
      node.addEventListener(
        'load',
        () => {
          node.dataset.patineLoaded = 'true';
          resolve();
        },
        { once: true },
      );
      node.addEventListener('error', reject, { once: true });

      if (!existing) document.head.appendChild(node);
    });
  };

  const notifyReady = () => {
    window.dispatchEvent(new CustomEvent('patine:animations-ready', { detail: window.PatineAnimations || null }));
    return window.PatineAnimations || null;
  };

  const load = () => {
    if (readyPromise) return readyPromise;

    if (reducedMotion) {
      readyPromise = Promise.resolve().then(notifyReady);
      return readyPromise;
    }

    readyPromise = loadScript(sources.gsapSrc)
      .then(() => loadScript(sources.scrollTriggerSrc))
      .then(() => loadScript(sources.lenisSrc))
      .then(() => loadScript(sources.animationsSrc))
      .then(() => loadScript(sources.sectionAnimationsSrc))
      .then(notifyReady)
      .catch((error) => {
        console.error('Patine animation loader failed', error);
        window.dispatchEvent(new CustomEvent('patine:animations-error', { detail: error }));
        return null;
      });

    return readyPromise;
  };

  const whenReady = (callback) => {
    load().then(callback);
  };

  const hasAnimationSurface = () => document.querySelector(animationSelectors.join(','));

  window.PatineAnimationLoader = {
    load,
    whenReady,
    hasAnimationSurface,
  };

  const loadOnInteraction = () => {
    window.removeEventListener('pointerdown', loadOnInteraction);
    window.removeEventListener('keydown', loadOnInteraction);
    window.removeEventListener('touchstart', loadOnInteraction);
    window.removeEventListener('wheel', loadOnInteraction);
    load();
  };

  if (hasAnimationSurface()) {
    load();
  } else {
    window.addEventListener('pointerdown', loadOnInteraction, { passive: true });
    window.addEventListener('keydown', loadOnInteraction);
    window.addEventListener('touchstart', loadOnInteraction, { passive: true });
    window.addEventListener('wheel', loadOnInteraction, { passive: true });
  }
})();
